function SettingsPage() {
  return <div>⚙️ Profile & Business Settings are under production</div>;
}

export default SettingsPage;
